exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".embed-carousel-wrapper[data-v-16b0db23]{width:100%;padding-bottom:10px}", ""]);

// exports
